import { render, staticRenderFns } from "./ReservationTicket.vue?vue&type=template&id=8a4283ca&scoped=true&"
var script = {}
import style0 from "./ReservationTicket.vue?vue&type=style&index=0&id=8a4283ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4283ca",
  null
  
)

export default component.exports